export const CLIENTS_SLUGS = {
    DANONE_ONE: 'danone-one',
    JTI_CONNECT: 'jti-connect',
    DOTS: 'dots',
    DOTS_II: 'dots-ii',
    KC: 'kimberly-one',
    SALESBOOK: 'salesbook-one',
    WWP: 'wwp-winwiththepartner',
    SP: 'shell-somosprotagonistas',
    WTS: 'beiersdorf-wts',
    MARS: 'mars-betthertogether',
    SAVENCIA: 'savencia-one',
    MITSUBISHI: 'one-mitsubishi',
    AURA: 'aura-one',
    LESAFFRE: 'lesaffre-one',
    PFIZER: 'one-pfizer',
    BRANCA: 'branca-one',
    AXUM: 'axum-one',
    MEGALABS: 'one-megalabs'
};

/**
 * @description Campos del perfil que NO son editables por cliente.
 * Sin entrada = todos los campos son editables.
 * Para deshabilitar un campo en un cliente, agregar su slug aquí.
 * fields: "Email", "Teléfono", "Nombre", "Apellido", "Rol", "Area"
 */
export const PROFILE_NON_EDITABLE_FIELDS: Record<string, string[]> = {
    [CLIENTS_SLUGS.SP]: ['Nombre', 'Apellido'],
    // [CLIENTS_SLUGS.DOTS_II]: ['Email'],
};